/* eslint-disable no-shadow */
import {DeliveryLocationStatus} from '@buncha/batchDetails/types';
import {Run} from '@buncha/AboutShift/types';

export interface OrderExtraInfo {
  reschedule: {
    oldRunId?: number;
    reason?: string;
  };
}

export interface ContactDetails {
  id: string;
  email: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  updatedAt: string;
}

export interface AssigneeDetails {
  id: string;
  email: string;
  phone: string;
  name: string;
  imageUrl?: string;
}

export interface OrderFeedback {
  id: string;
  createdAt: string;
  updatedAt: string;
  rateCount: number;
  orderId: string;
  note: string;
}

export enum PartnerDeliveryStatus {
  confirmed = 'CONFIRMED',
  claimed = 'CLAIMED',
  shopped = 'SHOPPED',
  delivered = 'DELIVERED',
  cancelled = 'CANCELLED',
  reSchedule = 'RESCHEDULED',
}

export enum OrderHistoryStatus {
  notStarted = DeliveryLocationStatus.notStarted,
  readyToPack = DeliveryLocationStatus.readyToPack,
  orderPacked = DeliveryLocationStatus.orderPacked,
  toBeAssigned = DeliveryLocationStatus.toBeAssigned,
  driverAssigned = DeliveryLocationStatus.driverAssigned,
  awaitingHandover = DeliveryLocationStatus.awaitingHandover,
  handoverFailed = 'handoverFailed',
  onTheWay = DeliveryLocationStatus.onTheWay,
  readyForPickup = DeliveryLocationStatus.readyForPickup,
  deliveryFailed = DeliveryLocationStatus.deliveryFailed,
  delivered = DeliveryLocationStatus.delivered,
  receiptGenerated = DeliveryLocationStatus.receiptGenerated,
  cancelled = DeliveryLocationStatus.cancelled,
  refunded = DeliveryLocationStatus.refunded,
  shoppingInProgress = 'shoppingInProgress',
  inTransit = 'inTransit',
}

export interface OrderHistory {
  id: number;
  tableName: string;
  tableId: string;
  tableLegacyId: number;
  createdAt: string;
  updatedAt: string;
  status: OrderHistoryStatus;
  actionBy?: string;
  extraInfo?: any;
}
export interface B2BOrder {
  id: string;
  legacyId: number;
  userOrganizationInfoId: string;
  timeSlotId: string;
  deliveryAddressId: string;
  organizationId: string;
  contactInfoId: string;
  status: DeliveryLocationStatus;
  substitutionPreference: string;
  deliveryNotes: string;
  externalOrderId: string;
  tipAmount: number;
  createdAt: string;
  updatedAt: string;
  bagsUsed: number;
  extraInfo?: OrderExtraInfo;
  deliveredOn: string | null;
  preferEarlyDelivery: boolean;
  orderMovedReq: {
    messageTime: Date;
  };
}

export enum OrderInfoParamsSource {
  Reschedule = 'Reschedule',
  Cancel = 'Cancel',
}

export type OrderInfoParams =
  | {
      orderId?: string;
      source?: OrderInfoParamsSource;
    }
  | undefined;

export interface VendorDelivery {
  code: string;
  name: string;
  dropoffEtaEstimated?: string;
}

export interface OrderData {
  order: B2BOrder;
  run: Run;
  deliveryAddress: {
    id: string;
    legacyId: number;
    line1?: string;
    line2?: string;
    city?: string;
    zip: string;
    state?: string;
    createdAt: string;
    updatedAt: string;
  };
  deliveryInfo: {
    id: string;
    orderId: string;
    signature?: string;
    deliveryImages?: string[];
    idProof?: string;
    createdAt: string;
    updatedAt: string;
    location: string;
    onFleetTaskId?: string;
    deliveryFailedReason?: string;
    legacyId: number;
    note?: string;
  };
  orderHistory: OrderHistory[];
  contactDetails: ContactDetails;
  assigneeDetails?: AssigneeDetails;
  orderFeedback?: OrderFeedback;
  preferredShopperId: number | null;
  driverDetails: AssigneeDetails;
  shopperDetails: AssigneeDetails;
  vendorDelivery: VendorDelivery;
}

export interface AssigneeFeedbackSummary {
  assigneeId: string;
  totalOrders: number;
  averageRateCount: number;
}

export interface B2BAssignee {
  id: number;
  email: string;
  phone: string;
  name: string;
  imageUrl: string;
}

export interface B2BAssigneeDetails {
  assignee: B2BAssignee;
  feedbackSummary: AssigneeFeedbackSummary;
}
